import React, { useState } from "react";
import styled from "styled-components";
import { Link, withRouter } from "react-router-dom";
import { calculateProductId } from "../../organisms/GenericForm/utils/calculateProductId";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import {
  CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
  CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO,
  CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO,
  CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO,
  SERVICE_ID_TELCEL_PAQUETES_MIXTOS,
  SERVICE_ID_TELCEL_PAQUETES_POSPAGO,
  SERVICE_ID_TELCEL_PLANES
} from "../../../constants";
import { validateUserAgent } from "../../../components/organisms/utils";
import InternetByTimeCard from "../../molecules/Plans/InternetByTimeCard";
// import RightCardPackage from "../../molecules/RightCardPackage";

const Container = styled.div`
  width: 100%;
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "0% 0% 0% 0%"};
  text-align: ${(props) => (props.align != undefined ? props.align : "left")};
`;

const Card = styled.div`
  margin: 5% auto;
  padding: 0em 0em 0em 0em;
  width: 94%;
  text-align: center;
  box-shadow: 0px 0px 31px 0px rgba(1, 32, 36, 0.15);
  border-radius: ${props => props.isContainerTelcel ? "10px" : "5px"};
`;

const Table = styled.table`
  margin: 0% 0% 0% 0%;
  padding: 0% 0% 0% 0%;
  width: 100%;
  border: none;
  border-spacing: 0;
`;

const Title = styled.p`
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px!important"};
  font-family: ${(props) =>
    props.font != undefined ? props.font : "RobotoBold"};
  color: ${(props) => (props.color != undefined ? props.color : "#50626c")};
  text-align: ${(props) => (props.align != undefined ? props.align : "left")};
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "0% 0% 0% 0%"};
  margin: ${(props) =>
    props.margin != undefined ? props.margin : "0% 0% 0% 0%"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "normal"};
`;

const TitleDescription = styled.p`
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px!important"};
  color: ${(props) => (props.color != undefined ? props.color : "#50626c")};
  text-align: ${(props) => (props.align != undefined ? props.align : "left")};
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "0% 0% 0% 0%"};
  margin: ${(props) =>
    props.margin != undefined ? props.margin : "0% 0% 0% 0%"};
  font-weight: 500;
  font-family: ${props => props.fontFamily ? props.fontFamily : "Roboto"};
`;

const Span = styled.span`
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px!important"};
  font-family: ${(props) =>
    props.font != undefined ? props.font : "RobotoBold"};
  color: ${(props) => (props.color != undefined ? props.color : "#50626c")};
  text-align: ${(props) => (props.align != undefined ? props.align : "left")};
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "0% 0% 0% 0%"};
  margin: ${(props) =>
    props.margin != undefined ? props.margin : "0% 0% 0% 0%"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "normal"};
  white-space: ${(props) =>
    props.whiteSpace != undefined ? props.whiteSpace : "pre-wrap"};
  vertical-align: ${(props) =>
    props.verticalAlign != undefined ? props.verticalAlign : "baseline"};
`;

const ContainerPospago = styled.div`
  display: grid;
  grid-template-columns: ${props => props.isContainerTelcel ? "24px auto" : "20% 80%"};
  ${props => props.isContainerTelcel ? "column-gap: 10px" : ""}
  ${props => props.isContainerTelcel ? "padding: 5px 10px 10px 10px" : ""}
  margin-top: ${props => props.isContainerTelcel ? "0" : "3%"};
`;
const Costo = styled.div`
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px!important"};
  font-family: ${(props) =>
    props.font != undefined ? props.font : "RobotoBold"};
  color: ${(props) => (props.color != undefined ? props.color : "#50626c")};
  text-align: ${(props) => (props.align != undefined ? props.align : "left")};
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "0% 0% 0% 0%"};
  margin: ${(props) =>
    props.margin != undefined ? props.margin : "0% 0% 0% 0%"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "normal"};
  white-space: ${(props) =>
    props.whiteSpace != undefined ? props.whiteSpace : "pre-wrap"};
  vertical-align: ${(props) =>
    props.verticalAlign != undefined ? props.verticalAlign : "baseline"};
  & div {
    margin-left: 7%;
  }
`;
const Th = styled.th`
  border-top: ${(props) =>
    props.borderTop != undefined ? props.borderTop : "2px solid #e8e7e5"};
  border-right: ${(props) =>
    props.borderRight != undefined ? props.borderRight : "2px solid #e8e7e5"};
  border-bottom: ${(props) =>
    props.borderBottom != undefined ? props.borderBottom : "2px solid #e8e7e5"};
  border-left: ${(props) =>
    props.borderLeft != undefined ? props.borderLeft : "2px solid #e8e7e5"};
  padding: ${(props) => (props.padding != undefined ? props.padding : "3% 3%")};
  text-align: ${(props) =>
    props.textAlign != undefined ? props.textAlign : "left"};
  width: ${(props) => (props.width != undefined ? props.width : "60%")};
  background-color: ${(props) =>
    props.backgroundColor != undefined ? props.backgroundColor : "#FFFFFF"};
`;

const ThTemp = styled.th`
  border-top: ${(props) =>
    props.borderTop != undefined ? props.borderTop : "none"};
  border-right: ${(props) =>
    props.borderRight != undefined ? props.borderRight : "2px solid #e8e7e5"};
  border-bottom: ${(props) =>
    props.borderBottom != undefined ? props.borderBottom : "2px solid #e8e7e5"};
  border-left: ${(props) =>
    props.borderLeft != undefined ? props.borderLeft : "2px solid #e8e7e5"};
  padding: ${(props) => (props.padding != undefined ? props.padding : "3% 3%")};
  text-align: ${(props) =>
    props.textAlign != undefined ? props.textAlign : "left"};
  width: ${(props) => (props.width != undefined ? props.width : "60%")};
  background-color: ${(props) =>
    props.backgroundColor != undefined ? props.backgroundColor : "#FFFFFF"};
`;

const Button = styled.div`
  border: ${(props) =>
    props.border != undefined ? props.border : "2px solid black"};
  border-radius: ${(props) =>
    props.borderRadius != undefined ? props.borderRadius : "25px"};
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px"};
  background: ${(props) =>
    props.background != undefined ? props.background : "black"};
  color: ${(props) => (props.color != undefined ? props.color : "white")};
  text-align: center;
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "10px 0px"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "normal"};
  margin: ${(props) => (props.margin != undefined ? props.margin : "0%")};
  ${(props) => (props.font ? `font-family: ${props.font}` : "")};
`;

const ButtonAdvancementClaroPay = styled.div`
  border: 2px solid #1470d1;
  border-radius: ${(props) =>
    props.borderRadius != undefined ? props.borderRadius : "25px"};
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px"};
  background: #1470d1;
  backgroundcolor: #1470d1;
  color: #ffffff;
  text-align: center;
  padding: ${(props) =>
    props.padding != undefined ? props.padding : "10px 0px"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "normal"};
  margin: ${(props) => (props.margin != undefined ? props.margin : "0%")};
  ${(props) => (props.font ? `font-family: ${props.font}` : "")};
`;

const ButtonUnder = styled.span`
  font-size: ${(props) =>
    props.fontSize != undefined ? props.fontSize : "12px"};
  font-weight: ${(props) =>
    props.weight != undefined ? props.weight : "bold"};
  text-decoration: underline;
  color: ${(props) =>
    props.color != undefined ? props.color : "rgb(80, 98, 108)"};
  ${(props) => (props.font ? `font-family: ${props.font}` : "")};
`;

const IngoMb = styled.div`
  font-size: 9px;
  color: #fff;
  font-family: "RobotoRegular";
  background: ${(props) =>
    props.backgroundColor != undefined
      ? props.backgroundColor
      : "rgb(37, 74, 165)"};
  text-align: center;
  border-radius: 0px 5px 2px 18px;
  padding: 6%;
  float: right;
  margin: ${(props) =>
    props.margin != undefined ? props.margin : "0% 0% 0% 0%"};
`;

const HeaderPlans = ({
  serviceConfigIndex,
  plans,
  disableSeeMoreButton,
  handleButonSeeMore,
  paymentsConfig,
  sdkClaroVersion,
  isClaroPartner,
  tagServiceId,
  executeTaggeoHandle,
  paramsNewOfferTelcel,
  withOfferTelcelWithoutLine,
  isContainerTelcel,
  isAnonimous,
  approvedToAdvancementClaroPay,
  paymentMethod,
  history,
  ...restOfProps
}) => {
  const [textButton, setTextButton] = React.useState("");

  React.useEffect(() => {
    setTextButton(isContainerTelcel ? "Lo quiero" : "Lo quiero");
  }, []);

  const [isPospagoEventual] = useState(
    paymentsConfig &&
    paymentsConfig.services &&
    paymentsConfig.services[serviceConfigIndex] &&
    (
      paymentsConfig.services[serviceConfigIndex].serviceData.info.serviceId == SERVICE_ID_TELCEL_PAQUETES_POSPAGO ||
      paymentsConfig.services[serviceConfigIndex].serviceData.info.serviceId == SERVICE_ID_TELCEL_PAQUETES_MIXTOS
    )
  );

  const service_id = paymentsConfig.services[serviceConfigIndex].serviceData.info.serviceId;

  function getSrcImage(network) {
    switch (network) {
      case "Facebook":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "Face.png";
      case "Messenger":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "Messenger.png";
      case "Twitter":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "X_v2.png";
      case "Instagram":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "Insta.png";
      case "Snapchat":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "Snap.png";
      case "WhatsApp":
        return process.env.REACT_APP_IMAGES_CONTAINER_TELCEL + "Whats.png";
      default:
        return "";
    }
  }
  function getImageInter(internet) {
    switch (internet) {
      default:
        return !isContainerTelcel || isPospagoEventual
          ? "/images/social_networks/logo_internet.svg"
          : "/images/social_networks/globe_02.png";
    }
  }
  function getUrl() {
    const linkInformation = JSON.stringify({
      app: "https",
      url: "https://www.telcel.com/",
    });
    sdkclaro.getInstance().openNative(
      linkInformation,
      () => {},
      () => {}
    );
  }
  function getVigencia(days) {
    if(days === "1" || days === 1){
      return `${days} día`;
    } else if(days === "365" || days === 365){
      return `12 meses`;
    }  else if(days === "182" || days === 182){
      return `6 meses`;
    } else {
      return `${days} días`;
    }
  }

  const handleBodyPlanCardClick = ({ ...propsToSendToLink }) => {
    console.log(
      "handleBodyPlanCardClick",
      "propsToSendToLink",
      propsToSendToLink
    );
    history.push({
      pathname: "/plans",
      state: {
        ...propsToSendToLink,
      },
    });

    executeTaggeoHandle(
      propsToSendToLink.planCost,
      propsToSendToLink.productId
    );
  };
  let planCard = [];
  // let planCard2 = [];
  let validity = [];
  let textLink = [];
  let displayTitleUnlimited = "block";
  let displayCard = "block";
  let displaySeeMoreButton = "block";
  const { categoryPlansId } =
    paymentsConfig.services[serviceConfigIndex].serviceData.info;
  if (disableSeeMoreButton) {
    displaySeeMoreButton = "none";
  }

  const executeOnClick = (amount, productId, mb, isAdvancementClaroPay) => {
	executeTaggeoHandle(
		amount,
		productId,
		isAdvancementClaroPay ? "adelanto" : ""
	);

	const propsToSendToLink = {
		sdkVersion: sdkClaroVersion,
		paymentsConfig: paymentsConfig,
		isClaroPartner: isClaroPartner,
		amountPlan: amount,
		productId: productId,
		serviceConfigIndex: serviceConfigIndex,
		tagServiceId: tagServiceId,
		paramsNewOfferTelcel: paramsNewOfferTelcel,
		isContainerTelcel: isContainerTelcel,
		idCategory: plans.service.id,
		mb: mb,
		planCost: amount,
		isAdvancementClaroPay: isAdvancementClaroPay
	}

	history.push({
		pathname: "/plans",
		state: propsToSendToLink,
	});
}
	
  if (plans) {
    plans.detail
      .filter((planFilter) =>
        paymentMethod && paymentMethod.value === "advancement-claro-pay"
          ? planFilter.useAdvacepayment
          : planFilter.cost
      )
      .map(function (plan, key) {
        const { promotions } = plan;
        let productId = calculateProductId(
          plan.id,
          plan.cost,
          paymentsConfig.services[serviceConfigIndex].serviceData.info
            .categoryPlansId,
          plan.idExternal
        );
        let plan15 = plan.id ? plan.id == 47 : "";
        let plan10 = plan.id ? plan.id == 48 : "";
        let plan412 = plan.id ? plan.id === 67 : "";
        let plan417 = plan.id ? plan.id === 68 : "";
		let plan79 = plan.id ? plan.id === 79 : "";
		let plan80 = plan.id ? plan.id === 80 : "";

        const hasPromotions =
          promotions &&
          Object.keys(promotions).length &&
          (
			(!isContainerTelcel && promotions.PromotionMegas500) ||
			(isContainerTelcel && promotions.PromotionMegas500C)
		  )
		;

        const hasPromotionsAnonimo =
          promotions &&
          Object.keys(promotions).length &&
          promotions.PromotionAnonymous;

		
		// Promotion temp image
		let promotionTempImage;

		if (isContainerTelcel && promotions && promotions.PromotionTempC) {
			promotionTempImage = promotions.PromotionTempC;
		}

		if (!isContainerTelcel && promotions && promotions.PromotionTemp) {
			promotionTempImage = promotions.PromotionTemp;
		}
		// End promotion temp

		// Promotion megas500
		let PromotionMegas500;

		if (isContainerTelcel && promotions && promotions.PromotionMegas500C) {
			PromotionMegas500 = promotions.PromotionMegas500C;
		}

		if (!isContainerTelcel && promotions && promotions.PromotionMegas500) {
			PromotionMegas500 = promotions.PromotionMegas500;
		}
		//

        if (plan.unlimitedSocialNetworks.socialNetworks.length <= 3) {
          displayTitleUnlimited = "inline";
        } else {
          displayTitleUnlimited = "block";
        }
        if (key <= 2) {
          displayCard = "block";
        } else {
          if (disableSeeMoreButton) {
            displayCard = "block";
          } else {
            displayCard = "none";
          }
        }

        let marginButtonLoQuiero = "10% 0%";
        if (plan.mbInternet != 0) {
          if (hasPromotions) {
            marginButtonLoQuiero = "30% 0% 0% 0%";
          } else {
            marginButtonLoQuiero = isContainerTelcel && isPospagoEventual ? "0px" : "20% 0%";
          }
        }
       
		/**
		 * New Compnent for Internet by time
		 */
		if (
			service_id &&
			plans.service && 
			plans.service.id &&
			(
				(service_id == SERVICE_ID_TELCEL_PLANES && plans.service.id == CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO) || 
				(service_id == SERVICE_ID_TELCEL_PAQUETES_MIXTOS && plans.service.id == CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO)
			)
		) {
			planCard.push(
				<InternetByTimeCard 
					plan={plan}
					productId={productId}
					executeOnClick={executeOnClick} 
					approvedToAdvancementClaroPay={approvedToAdvancementClaroPay}
				/>
			)
		/** 
		 * End 
		*/
		} else {		
			planCard.push(
			<Card style={{ display: displayCard }} isContainerTelcel={isContainerTelcel}>
				<div
				onClick={(e) => {
					if (isContainerTelcel)
					handleBodyPlanCardClick({
						sdkVersion: sdkClaroVersion,
						paymentsConfig: paymentsConfig,
						isClaroPartner: isClaroPartner,
						amountPlan: plan.cost,
						productId: productId,
						serviceConfigIndex: serviceConfigIndex,
						tagServiceId: tagServiceId,
						paramsNewOfferTelcel: paramsNewOfferTelcel,
						isContainerTelcel: isContainerTelcel,
						idCategory: plans.service.id,
						mb: plan.mb,
						planCost: plan.cost,
					});
				}}
				>
				<Table>
					{!isPospagoEventual && (
					<>
						{/* Superior ___ No-pospagoEventual */}
						<Th
						borderBottom="none"
						borderRight="none"
						borderTop="none"
						borderLeft="none"
						padding="0%"
						style={{
							borderRadius: isContainerTelcel
							? "10px 0px 0px 0px"
							: "0px",
						}}
						></Th>
						<Th
						width="40%"
						borderBottom="none"
						borderTop="none"
						borderRight="none"
						padding="0%"
						borderLeft={
							isContainerTelcel && !isClaroPartner
							? "1px solid #bac9d8"
							: undefined
						}
						style={{
							borderRadius: isContainerTelcel
							? "0px 10px 0px 0px"
							: "0px",
						}}
						>
						{plan.hasPromotion && !hasPromotions && !hasPromotionsAnonimo ? (
							<IngoMb margin="-.5% -.5% 0% 0%"> + {plan.mb}MB</IngoMb>
						) : (
							<IngoMb backgroundColor="rgba(255, 255, 255)" style={ isContainerTelcel ? {borderRadius: "0px 10px 0px 0px"} : {} }> </IngoMb>
						)}
						</Th>
					</>
					)}
					{plan.mbSocialNetworks.socialNetworks.length != 0 ? (
					<tr>
						<Th
						borderTop="none"
						borderBottom="none"
						borderRight="none"
						borderLeft="none"
						>
						<Title
							align={"left"}
							weight={"bold"}
							margin={"0% 0% 2% 0%"}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: "RobotoBold"
							}
							fontSize={
							isContainerTelcel && !isClaroPartner ? "15px" : "14px"
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
						>
							{plan.mbSocialNetworks.mb + " MB"}
						</Title>
						<Container align={"left"}>
							{plan.mbSocialNetworks.socialNetworks.map(function (
							network
							) {
							return (
								<img
								src={getSrcImage(network)}
								style={
									isContainerTelcel && !isClaroPartner
									? { marginRight: "12px", width: "20px" }
									: { marginRight: "3%", width: "20px" }
								}
								/>
							);
							})}
						</Container>
						</Th>
						<Th
						rowSpan="4"
						width="40%"
						borderTop="none"
						borderRight="none"
						borderBottom="none"
						borderLeft={
							isContainerTelcel && !isClaroPartner
							? "1px solid #bac9d8"
							: undefined
						}
						padding="0% 3% 3% 3%"
						style={{ borderRadius: isContainerTelcel ? (isPospagoEventual ? "0px 10px 10px 0px" : "0px 0px 10px 0px") : "0px", }}
						>
						<Title
							fontSize={"14px"}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Regular"
								: undefined
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
							margin={isContainerTelcel ? (isPospagoEventual ? "0px 0px 5px 0px" : "0px 0px 8px 12px") : "0% 0% 10% 0%"}
						>
							Costo
						</Title>
						<Title
							fontSize={
							isContainerTelcel && !isClaroPartner ? "20px" : "18px"
							}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: undefined
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#008000"
								: "#a6ce4e"
							}
							margin={
							isContainerTelcel && !isClaroPartner
								? "0px 0px 9px 12px"
								: "0% 0% 2% 0%"
							}
						>
							{"$" + plan.cost}
						</Title>

						<Title
							fontSize={"11px"}
							font={
							isContainerTelcel && !isClaroPartner
								? isContainerTelcel? "AMX-Bold" : "AMX-Medium"
								: undefined
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
							margin={
							isContainerTelcel && !isClaroPartner
								? "0px 0px 45px 12px"
								: "1% % 1% 0%"
							}
							weight={
							isContainerTelcel && !isClaroPartner
								? "normal"
								: "medium"
							}
						>
							{"Vigencia: " +getVigencia(plan.validityDays)}
						</Title>

						{parseInt(plan.cost) <= 100 &&
						approvedToAdvancementClaroPay ? (
							<Link
							to={{
								pathname: "/plans",
								state: {
								sdkVersion: sdkClaroVersion,
								paymentsConfig: paymentsConfig,
								isClaroPartner: isClaroPartner,
								amountPlan: plan.cost,
								productId: productId,
								serviceConfigIndex: serviceConfigIndex,
								tagServiceId: tagServiceId,
								paramsNewOfferTelcel: paramsNewOfferTelcel,
								isContainerTelcel: isContainerTelcel,
								idCategory: plans.service.id,
								mb: plan.mb,
								isAdvancementClaroPay: true,
								},
							}}
							>
							<ButtonAdvancementClaroPay
								margin={marginButtonLoQuiero}
								onClick={() =>
								executeTaggeoHandle(
									plan.cost,
									productId,
									"adelanto"
								)
								}
								borderRadius={
								isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font={
								isContainerTelcel && !isClaroPartner
									? "AMX-Bold"
									: undefined
								}
								fontSize={
								isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								height={"4em"}
								width={"11em"}
								padding={
								isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
							>
								{"Usar adelanto"}
							</ButtonAdvancementClaroPay>
							</Link>
						) : null}

						{(paymentMethod &&
							paymentMethod.value !== "advancement-claro-pay") ||
						!paymentMethod ? (
							<Link
							onClick={(e) =>
								isContainerTelcel ? e.preventDefault() : {}
							}
							to={
								isContainerTelcel
								? {
									hash: "#",
									}
								: {
									pathname: "/plans",
									state: {
										sdkVersion: sdkClaroVersion,
										paymentsConfig: paymentsConfig,
										isClaroPartner: isClaroPartner,
										amountPlan: plan.cost,
										productId: productId,
										serviceConfigIndex: serviceConfigIndex,
										tagServiceId: tagServiceId,
										paramsNewOfferTelcel: paramsNewOfferTelcel,
										isContainerTelcel: isContainerTelcel,
										idCategory: plans.service.id,
										mb: plan.mb,
									},
									}
							}
							>
							<Button
								backgroundColor="#ffffff"
								margin={marginButtonLoQuiero}
								onClick={() =>
								isContainerTelcel
									? {}
									: executeTaggeoHandle(plan.cost, productId)
								}
								border={
								isContainerTelcel && !isClaroPartner
									? "2px solid #7b1fa2"
									: undefined
								}
								borderRadius={
								isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font="AMX-Bold"
								fontSize={
								isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								color={
								isContainerTelcel && !isClaroPartner
									? "white"
									: "#fff"
								}
								height={"4em"}
								width={"11em"}
								background={
								isContainerTelcel && !isClaroPartner
									? "#7b1fa2"
									: "#000"
								}
								padding={
								isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
							>
								{textButton}
							</Button>
							</Link>
						) : null}
						</Th>
					</tr>
					) : (
					<></>
					)}
					{plan.unlimitedSocialNetworks.socialNetworks.length != 0 ? (
					<tr>
						<Th
						borderTop="none"
						borderBottom="none"
						borderRight="none"
						borderLeft="none"
						padding={
							plan.mbInternet != 0 ? "0% 3% 3% 3%" : "0% 3% 3% 3%"
						}
						>
						<Title
							align={"left"}
							weight={"bold"}
							margin={"0% 0% 2% 0%"}
							style={{ display: displayTitleUnlimited }}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: "RobotoBold"
							}
							fontSize={
							isContainerTelcel && !isClaroPartner ? "15px" : "14px"
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
						>
							{"Ilimitado:"}&nbsp;
						</Title>

						{plan.unlimitedSocialNetworks.socialNetworks.map(
							function (network, index) {
							return (
								<img
								src={getSrcImage(network)}
								style={{
									marginRight: "3%",
									width: "20px",
									verticalAlign: "inherit",
									marginLeft: index == 0 ? "0%" : "3%",
								}}
								/>
							);
							}
						)}
						</Th>
						{plan.mbSocialNetworks.socialNetworks.length == 0 ? (
						<Th
							rowSpan="4"
							borderTop="none"
							borderRight="none"
							borderBottom="none"
							borderLeft={
							isContainerTelcel && !isClaroPartner
								? "1px solid #bac9d8"
								: undefined
							}
							padding="0% 3% 3% 3%"
							style={{ borderRadius: isContainerTelcel ? (isPospagoEventual ? "0px 10px 10px 0px" : "0px 0px 10px 0px") : "0px", }}
						>
							<Title
							fontSize={"14px"}
							font={
								isContainerTelcel && !isClaroPartner
								? "AMX-Regular"
								: undefined
							}
							color={
								isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
							margin={isContainerTelcel ? (isPospagoEventual ? "0px 0px 5px 0px" : "0px 0px 8px 12px") : "0% 0% 10% 0%"}
							>
							Costo
							</Title>
							<Title
							fontSize={
								isContainerTelcel && !isClaroPartner
								? "20px"
								: "18px"
							}
							font={
								isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: undefined
							}
							color={
								isContainerTelcel && !isClaroPartner
								? "#008000"
								: "#a6ce4e"
							}
							margin={
								isContainerTelcel && !isClaroPartner
								? "0px 0px 9px 12px"
								: "0% 2% 2% 0%"
							}
							>
							{"$" + plan.cost}
							</Title>

							<Title
							fontSize={"11px"}
							font={
								isContainerTelcel && !isClaroPartner
								? "AMX-Medium"
								: undefined
							}
							color={
								isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
							margin={
								isContainerTelcel && !isClaroPartner
								? "0px 0px 45px 12px"
								: "1% % 1% 0%"
							}
							weight={
								isContainerTelcel && !isClaroPartner
								? "normal"
								: "medium"
							}
							>
							{"Vigencia: " +getVigencia(plan.validityDays)}
							</Title>
							{parseInt(plan.cost) <= 100 &&
							approvedToAdvancementClaroPay ? (
							<Link
								to={{
								pathname: "/plans",
								state: {
									sdkVersion: sdkClaroVersion,
									paymentsConfig: paymentsConfig,
									isClaroPartner: isClaroPartner,
									amountPlan: plan.cost,
									productId: productId,
									serviceConfigIndex: serviceConfigIndex,
									tagServiceId: tagServiceId,
									paramsNewOfferTelcel: paramsNewOfferTelcel,
									isContainerTelcel: isContainerTelcel,
									idCategory: plans.service.id,
									mb: plan.mb,
									isAdvancementClaroPay: true,
								},
								}}
							>
								<ButtonAdvancementClaroPay
								margin={marginButtonLoQuiero}
								onClick={() =>
									executeTaggeoHandle(
									plan.cost,
									productId,
									"adelanto"
									)
								}
								borderRadius={
									isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font={
									isContainerTelcel && !isClaroPartner
									? "AMX-Bold"
									: undefined
								}
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								height={"4em"}
								width={"11em"}
								padding={
									isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
								>
								{"Usar adelanto"}
								</ButtonAdvancementClaroPay>
							</Link>
							) : null}
							{(paymentMethod &&
							paymentMethod.value !== "advancement-claro-pay") ||
							!paymentMethod ? (
							<Link
								onClick={(e) =>
								isContainerTelcel ? e.preventDefault() : {}
								}
								to={
								isContainerTelcel
									? {
										hash: "#",
										// we can send state too {}... but it gonna make hard to
										// keep this simple one (KISS) mostly important, we do not want to
										// repeat the supposed behavior (sent state twice and override the first state sent)
									}
									: {
										pathname: "/plans",
										state: {
										sdkVersion: sdkClaroVersion,
										paymentsConfig: paymentsConfig,
										isClaroPartner: isClaroPartner,
										amountPlan: plan.cost,
										productId: productId,
										serviceConfigIndex: serviceConfigIndex,
										tagServiceId: tagServiceId,
										paramsNewOfferTelcel:
											paramsNewOfferTelcel,
										idCategory: plans.service.id,
										mb: plan.mb,
										},
									}
								}
							>
								<Button
								backgroundColor="#ffffff"
								margin={marginButtonLoQuiero}
								onClick={() =>
									executeTaggeoHandle(plan.cost, productId)
								}
								border={
									isContainerTelcel && !isClaroPartner
									? "2px solid #7b1fa2"
									: undefined
								}
								borderRadius={
									isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font="AMX-Bold"
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								color={
									isContainerTelcel && !isClaroPartner
									? "white"
									: "#fff"
								}
								height={"4em"}
								width={"11em"}
								background={
									isContainerTelcel && !isClaroPartner
									? "#7b1fa2"
									: "#000"
								}
								padding={
									isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
								>
								{textButton}
								</Button>
							</Link>
							) : null}
						</Th>
						) : (
						<></>
						)}
					</tr>
					) : (
					<></>
					)}
					{plan.mbInternet != 0 || plan.mbInternetLabel ? (
					<tr>
						{plan.promotionLabel && !plan.mbInternetLabel ? (
						<Th
							width="60%"
							borderRight="none"
							borderBottom="none"
							borderLeft="none"
							backgroundColor={plan.promotionColor}
							padding={"0.2% 3%"}
						>
							<Span
							font={"RobotoBold"}
							fontSize={"12px"}
							color={"#FFFFFF"}
							align={"left"}
							weight={"bold"}
							margin={"0% 0% 0% 0%"}
							>
							{plan.promotionLabel}
							</Span>
							<Span
							font={"RobotoRegular"}
							fontSize={"12px"}
							color={"#FFFFFF"}
							align={"left"}
							margin={"0% 0% 2% 0%"}
							whiteSpace={"pre-wrap"}
							verticalAlign={"text-top"}
							>
							{`\npara navegar por internet`}
							</Span>
						</Th>
						) : (
						promotions && promotionTempImage
						? 
							validateUserAgent() === "android" ?
							<></>
							:
							<div style={{height: "0%"}}></div>
						:
						<Th
							width="60%"
							borderRight="none"
							borderBottom="none"
							borderLeft="none"
							textAlign="center"
							borderTop={
							isPospagoEventual
								? "none"
								: plan10 || plan15 || plan79
								? "none"
								: isContainerTelcel && !isClaroPartner
								? "1px solid #bac9d8"
								: undefined
							}
							style={{ 
							borderRadius: isContainerTelcel ? (isPospagoEventual ? "10px 0px 0px 10px" : "0px 0px 0px 10px") : "0px", 
							padding: isContainerTelcel && isPospagoEventual ? "10px 0px 5px 0px" : "",
							}}
						>
							{plan.megas &&
							(plan10 || plan15 || plan412 || plan417 || plan79 || plan80) ? (
							<Container align="center">
								<img
								src={getImageInter(plan.mb)}
								style={{
									marginRight:
									isContainerTelcel && !isClaroPartner
										? "0px"
										: "3%",
									marginBottom:
									isContainerTelcel && !isClaroPartner
										? "12px"
										: "0px",
									width:
									isContainerTelcel && !isClaroPartner
										? "32px"
										: "auto",
									height:
									isContainerTelcel && !isClaroPartner
										? "32px"
										: "auto",
								}}
								/>
							</Container>
							) : (
							<></>
							)}
							{plan.megas && (plan10 || plan15 || plan412 || plan417 || plan79 || plan80) ? (
							<>
								<Span
								font={
									isContainerTelcel && !isClaroPartner
									? "AMX-Bold"
									: "RobotoBold"
								}
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "16px"
									: "12px"
								}
								color={
									isContainerTelcel && !isClaroPartner
									? (isPospagoEventual ? "#222222" : "#0071d1")
									: "#50626c"
								}
								align={"left"}
								weight={
									isContainerTelcel && !isClaroPartner
									? "normal"
									: "bold"
								}
								margin={"0% 0% 0% 0%"}
								>
								{`${plan.megas}`}
								</Span>
								<Span
								font={
									(isContainerTelcel && !isClaroPartner) ||
									isPospagoEventual
									? "AMX-Regular"
									: "RobotoBold"
								}
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "16px"
									: "12px"
								}
								color={
									isContainerTelcel && !isClaroPartner
									? "#222222"
									: "#50626c"
								}
								align={"left"}
								margin={"0% 0% 2% 0%"}
								>
								{" para "}
								</Span>
								<Span
								font={
									(isContainerTelcel && !isClaroPartner) ||
									isPospagoEventual
									? "AMX-Regular"
									: "RobotoBold"
								}
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "16px"
									: "12px"
								}
								color={
									isContainerTelcel && !isClaroPartner
									? "#222222"
									: "#50626c"
								}
								align={"left"}
								margin={"0% 0% 2% 0%"}
								>
								{"\nnavegar en internet"}
								</Span>
							</>
							) : (
							<>
								{isPospagoEventual ? (
								<>
									<ContainerPospago isContainerTelcel={isContainerTelcel}>
									{ 
										!isContainerTelcel 
										?
										<>
										<div
											style={{
											display: "flex",
											alignItems: "center",
											}}
										>
											<img
											src={"/images/telcel_rss_feed.png"}
											style={{
												margin: "auto 0px 0px 0px",
												marginBottom:
												isContainerTelcel && !isClaroPartner
													? "12px"
													: "0px",
												width: "32px",
												height: "32px",
											}}
											/>
										</div>
										<div style={{ textAlign: "left" }}>
											<Span
											fontSize={"12px"}
											align={"left"}
											weight={"bold"}
											margin={"0% 0% 0% 0%"}
											font={
												isContainerTelcel && !isClaroPartner
												? "AMX-Bold"
												: "RobotoBold"
											}
											color={
												isContainerTelcel && !isClaroPartner
												? "#222222"
												: "#50626c"
											}
											>
											{isPospagoEventual
												? plan.mbInternetLabel
												? plan.mbInternetLabel
												: plan.mbInternet + " MB"
												: plan.mbInternetLabel ||
												plan.mbInternet + " MB"}
											</Span>
											<>{isPospagoEventual && <br />}</>
											<Span
											fontSize={"12px"}
											align={"left"}
											margin={"0% 0% 2% 0%"}
											font={
												isContainerTelcel && !isClaroPartner
												? "AMX-Regular"
												: isPospagoEventual
												? "Roboto"
												: "RobotoBold"
											}
											color={
												isContainerTelcel && !isClaroPartner
												? "#222222"
												: "#50626c"
											}
											style={
												isContainerTelcel && !isClaroPartner
												? { display: "inline-block" }
												: {}
											}
											>
											{plan.mbInternetLabel
												? " para navegar en internet"
												: ""}
											</Span>
										</div>                                      
										</>
										:
										<>
										<div>
											<img src="/images/telcel_rss_feed_container.png" width="24px" height="24px" />
										</div>
										<div>
											<p style={{ 
											color: "#222222",
											fontFamily: "AMX-Bold", 
											fontSize: "12px", 
											margin: "0px 0px 5px 0px", 
											textAlign: "left" 
											}}>
											{plan.mbInternetLabel}
											</p>
											<p style={{ 
											color: "#222222",
											fontFamily: "AMX-Regular", 
											fontWeight: "400",
											fontSize: "12px", 
											margin: "0px", 
											textAlign: "left" 
											}}>
											Para navegar en internet
											</p>
										</div>
										</>
									}                                  
									</ContainerPospago>
									{
									!isContainerTelcel
										?
										<Costo
											fontSize={"12px"}
											align={"left"}
											margin={"10% -7% 2% -7%"}
											padding={"5% 0% 0% 0%"}
											font={
											isContainerTelcel && !isClaroPartner
												? "AMX-Regular"
												: "Roboto"
											}
											color={
											isContainerTelcel && !isClaroPartner
												? "#222222"
												: "#50636c"
											}
											style={
											isContainerTelcel && !isClaroPartner
												? { display: "inline-block" }
												: {
													borderTop: "2px solid #e8e7e5",
													paddingTop:
													hasPromotions ||
													hasPromotionsAnonimo
														? "9%%"
														: "15%",
												}
											}
										>
											<div>
											Costo por MB: $
											{plan.costMb ? plan.costMb : ""}
											</div>
										</Costo>
										:
										<>
										<hr style={{ border: "0px", borderTop: "1px solid #e3e3e3", margin: "0px 0px 10px 0px" }} />
										<p style={{ 
											color: "#222222",
											fontFamily: "AMX-Regular", 
											fontWeight: "400",
											fontSize: "12px", 
											margin: "0px", 
											textAlign: "left", 
											padding: "0px 10px"
										}}>
											Costo por MB: ${plan.costMb ? plan.costMb : ""}
										</p>
										</>                                
									}
								</>
								) : (
								<>
									<>
									{
										plan.mbInternetLabel?
										<>
											<Span
												fontSize={"12px"}
												align={"left"}
												weight={"bold"}
												margin={"0% 0% 0% 0%"}
												font="AMX-Bold"
												color={
													isContainerTelcel && !isClaroPartner
													? "#222222"
													: "#50626c"
												}
												dangerouslySetInnerHTML={{__html: plan.mbInternetLabel}}
											/>
											<Span
												font={"AMX-Regular"}
												fontSize={"12px"}
												color={
													isContainerTelcel && !isClaroPartner
													? "#222222"
													: "#50626c"
												}
												margin={"0% 0% 0% 0%"}
											>
												&nbsp;para navegar en internet
											</Span>
										</>           
										:
										<>
										<Span
											fontSize={"12px"}
											align={"left"}
											weight={"bold"}
											margin={"0% 0% 0% 0%"}
											font="AMX-Bold"
											color={
											isContainerTelcel && !isClaroPartner
												? "#222222"
												: "#50626c"
											}
										>
											{plan.mbInternetLabel ||
											plan.mbInternet + " MB"}
										</Span>
										<Span
											fontSize={"12px"}
											align={"left"}
											margin={"0% 0% 2% 0%"}
											font={
											isContainerTelcel && !isClaroPartner
												? "AMX-Regular"
												: "AMX-Bold"
											}
											color={
											isContainerTelcel && !isClaroPartner
												? "#222222"
												: "#50626c"
											}
											style={
											isContainerTelcel && !isClaroPartner
												? { display: "inline-block" }
												: {}
											}
										>
											{plan.mbInternetLabel
											? ""
											: " para navegar en internet"}
										</Span>
										</>
									}
									</>
								</>
								)}
							</>
							)}
						</Th>
						)}
						{plan.mbSocialNetworks.socialNetworks.length == 0 &&
						plan.unlimitedSocialNetworks.socialNetworks.length == 0 ? (
						<Th
							rowSpan="2"
							borderTop="none"
							borderRight="none"
							borderBottom="none"
							padding={isPospagoEventual ? "15px 3% 3% 3%" : "0% 3% 3% 3%"}
							borderLeft={
							isContainerTelcel && !isClaroPartner
								? "1px solid #bac9d8"
								: undefined
							}
							style={{ borderRadius: isContainerTelcel ? (isPospagoEventual ? "0px 10px 10px 0px" : "0px 0px 10px 0px") : "0px", }}
						>
							<Title
							fontSize={"14px"}
							font={
								isContainerTelcel && !isClaroPartner
								? "AMX-Regular"
								: undefined
							}
							color={
								isContainerTelcel && !isClaroPartner
								? "#222222"
								: "#50626c"
							}
							margin={isContainerTelcel ? (isPospagoEventual ? "0px 0px 5px 0px" : "0px 0px 8px 12px") : "0% 0% 2% 0%"}
							>
							Costo
							</Title>
							<Title
							fontSize={
								isContainerTelcel && !isClaroPartner
								? "20px"
								: "18px"
							}
							font={
								isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: undefined
							}
							color={
								isContainerTelcel && !isClaroPartner
								? "#008000"
								: "#a6ce4e"
							}
							margin={isContainerTelcel ? (isPospagoEventual ? "0px 0px 5px 0px" : "0px 0px 9px 12px") : "0% 0% 2% 0%"}
							>
							{"$" + plan.cost}
							</Title>
							{plan.validityHours &&
							(plan10 || plan15 || plan412 || plan417 || plan79 || plan80) ? (
							<Title
								fontSize={"11px"}
								font={
								isContainerTelcel && !isClaroPartner
									? "AMX-Medium"
									: undefined
								}
								color={
								isContainerTelcel && !isClaroPartner
									? "#222222"
									: "#50626c"
								}
								margin={
								isContainerTelcel && !isClaroPartner
									? (isPospagoEventual ? "0px 0px 15px 0px" : "0px 0px 45px 12px")
									: "1% % 1% 0%"
								}
								weight={
								isContainerTelcel && !isClaroPartner
									? "normal"
									: "medium"
								}
							>
								{plan.validityHours == "1"
								? `Vigencia: ${plan.validityHours} hora`
								: `Vigencia: ${plan.validityHours} horas`}
							</Title>
							) : (
							<div>
								<Title
								fontSize={"11px"}
								color={"#50626c"}
								margin={"1% % 1% 0%"}
								weight={"meddium"}
								style={{ 
									marginBottom: isContainerTelcel ? (isPospagoEventual ? "3px" : "7px") : "7px" ,
									fontFamily: isContainerTelcel ? (isPospagoEventual ? "AMX-Bold" : "AMX-Regular") : undefined ,
								}}
								>
								{isPospagoEventual ? (
									!plan.validityHours ? (
									"Vigencia:"
									) : (
									<>
										{plan.validityHours === 1
										? "1 hora"
										: `Vigencia: ${plan.validityHours} horas`}
									</>
									)
								) : plan.validityDays == "1" ? (
									`Vigencia: ${plan.validityDays} día`
								) : (
									`Vigencia: ${plan.validityDays} días`
								)}
								</Title>
								<>
								{isPospagoEventual && !plan.validityHours && (
									<TitleDescription
									fontFamily={isContainerTelcel ? "AMX-Bold" : undefined}
									margin={
										hasPromotions || hasPromotionsAnonimo
										? (isContainerTelcel ? "0px 0px 15px 0px" : "0% 0% 25% 0%")
										: "0% 0% 15% 0%"
									}
									>
									al corte de factura
									</TitleDescription>
								)}
								</>
							</div>
							)}

							{parseInt(plan.cost) <= 100 &&
							approvedToAdvancementClaroPay ? (
							<Link
								to={{
								pathname: "/plans",
								state: {
									sdkVersion: sdkClaroVersion,
									paymentsConfig: paymentsConfig,
									isClaroPartner: isClaroPartner,
									amountPlan: plan.cost,
									productId: productId,
									serviceConfigIndex: serviceConfigIndex,
									tagServiceId: tagServiceId,
									paramsNewOfferTelcel: paramsNewOfferTelcel,
									isContainerTelcel: isContainerTelcel,
									idCategory: plans.service.id,
									mb: plan.mb,
									isAdvancementClaroPay: true,
								},
								}}
							>
								<ButtonAdvancementClaroPay
								margin={marginButtonLoQuiero}
								onClick={() =>
									executeTaggeoHandle(
									plan.cost,
									productId,
									"adelanto"
									)
								}
								borderRadius={
									isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font={
									isContainerTelcel && !isClaroPartner
									? "AMX-Bold"
									: undefined
								}
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								height={"4em"}
								width={"11em"}
								padding={
									isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
								>
								{"Usar adelanto"}
								</ButtonAdvancementClaroPay>
							</Link>
							) : null}
							{(paymentMethod &&
							paymentMethod.value !== "advancement-claro-pay") ||
							!paymentMethod ? (
							<Link
								onClick={(e) =>
								isContainerTelcel ? e.preventDefault() : {}
								}
								to={
								isContainerTelcel
									? {
										hash: "#",
									}
									: {
										pathname: "/plans",
										state: {
										sdkVersion: sdkClaroVersion,
										paymentsConfig: paymentsConfig,
										isClaroPartner: isClaroPartner,
										amountPlan: plan.cost,
										productId: productId,
										serviceConfigIndex: serviceConfigIndex,
										tagServiceId: tagServiceId,
										paramsNewOfferTelcel:
											paramsNewOfferTelcel,
										idCategory: plans.service.id,
										mb: plan.mb,
										},
									}
								}
							>
								<Button
								border={
									isContainerTelcel && !isClaroPartner
									? "2px solid #7b1fa2"
									: undefined
								}
								borderRadius={
									isContainerTelcel && !isClaroPartner
									? "18px"
									: undefined
								}
								font="AMX-Bold"
								fontSize={
									isContainerTelcel && !isClaroPartner
									? "13px"
									: "16px"
								}
								height={"4em"}
								width={"11em"}
								color={
									isContainerTelcel && !isClaroPartner
									? "white"
									: "#fff"
								}
								background={
									isContainerTelcel && !isClaroPartner
									? "#7b1fa2"
									: "#000"
								}
								margin={plan.mbInternet != 0 ? (isContainerTelcel && isPospagoEventual ? "0px 0px 7px 0px" : "20% 0%") : "5% 0%"}
								padding={
									isContainerTelcel && !isClaroPartner
									? "10px 0px 8.5px 0px"
									: undefined
								}
								style={{
									margin: isPospagoEventual &&
									(hasPromotions || hasPromotionsAnonimo)
										? (isContainerTelcel ? "0px" : "21% 0%")
										: "",
								}}
								>
								{textButton}
								</Button>
							</Link>
							) : null}
						</Th>
						) : (
						<></>
						)}
					</tr>
					) : (
					<></>
					)}
					{hasPromotions || hasPromotionsAnonimo ? (
					<tr>
						<Th
						padding="0px"
						borderRight="none"
						borderBottom="none"
						borderLeft="none"
						borderTop={
							isContainerTelcel && !isClaroPartner
							? "1px solid #bac9d8"
							: undefined
						}
						style={{
							borderRadius: isContainerTelcel
							? "0px 0px 0px 10px"
							: "0px",
							display: "grid",
							width: "100%",
						}}
						>
						<img
							src={
								!isAnonimous
									? promotions && promotionTempImage 
										? promotionTempImage 
										: PromotionMegas500
									: promotions && promotionTempImage 
										? promotionTempImage 
										: (PromotionMegas500 || promotions.PromotionAnonymous)
							}
							width={"100%"}
							style={isContainerTelcel ? {borderRadius: "0px 0px 0px 10px"} : {}}
						/>
						</Th>
					</tr>
					) : (
					<></>
					)}
					{plan.condition && (plan10 || plan79 || plan80) ? (
					<tr>
						<Th
						borderRight="none"
						borderBottom="none"
						borderLeft="none"
						borderTop={
							isContainerTelcel && !isClaroPartner
							? "1px solid #bac9d8"
							: undefined
						}
						textAlign="center"
						style={isContainerTelcel ? {borderRadius: "0px 0px 0px 10px"} : {}}
						>
						<Span
							weight={"normal"}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Regular"
								: "RobotoBold"
							}
							fontSize={
							isContainerTelcel && !isClaroPartner ? "16px" : "12px"
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#222222"
								: undefined
							}
						>
							{"Política de uso justo: "}
						</Span>
						<Span
							weight={
							isContainerTelcel && !isClaroPartner
								? "normal"
								: "bold"
							}
							font={
							isContainerTelcel && !isClaroPartner
								? "AMX-Bold"
								: "RobotoBold"
							}
							fontSize={
							isContainerTelcel && !isClaroPartner ? "16px" : "12px"
							}
							color={
							isContainerTelcel && !isClaroPartner
								? "#0071d1"
								: undefined
							}
						>
							{`${plan.condition}`}
						</Span>
						</Th>
					</tr>
					) : (
					<></>
					)}
				</Table>
				</div>
			</Card>
			);
		}
      });
  }
  if (plans) {
    plans.detail.map((plan, key) => {
      if (plan.promotionValidty) {
        const [textTitle, textDate] = plan.promotionValidty.split(":");
        validity.push(
          <>
            {plan.promotionValidty ? (
              <>
                <Title fontSize={"14px"} font={"RobotoRegular"}>
                  {`${textTitle}:`}
                </Title>
                <Span></Span>
                <Title fontSize={"14px"} weight={"bold"}>
                  {textDate}
                </Title>
              </>
            ) : (
              <></>
            )}
          </>
        );
      }
    });
  }
  if (plans) {
    if (
      plans.service.idService == "146" && plans.service.id === 8 ||
      (
        plans.service.idService == parseInt(SERVICE_ID_TELCEL_PAQUETES_POSPAGO) &&
        plans.service.id === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO
      ) ||
      (
        plans.service.idService == parseInt(SERVICE_ID_TELCEL_PAQUETES_MIXTOS) &&
        plans.service.id === CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO
      )    
    ) {
      textLink.push(
        <>
          <p style={ isPospagoEventual ? {width: "100%", textAlign: "center"} : {} }>
            <Title
              font={
                isContainerTelcel && !isClaroPartner
                  ? "AMX-Regular"
                  : "RobotoRegular"
              }
              fontSize={isContainerTelcel && !isClaroPartner ? "16px" : "14px"}
              color={isContainerTelcel && !isClaroPartner ? "#222222" : undefined}
              style={{ display: "inline-block" }}
            >
              {"Más información en "}
            </Title>
            <Span margin={"0% 2% 0% 0%"}></Span>
            <ButtonUnder
              onClick={getUrl}
              font={isContainerTelcel && !isClaroPartner ? "AMX-Bold" : undefined}
              fontSize={isContainerTelcel && !isClaroPartner ? "16px" : "14px"}
              color={isContainerTelcel && !isClaroPartner ? (isPospagoEventual ? "#222222" : "#0071d1") : undefined}
            >
              {"Telcel.com"}
            </ButtonUnder>
          </p>
        </>
      );
    }
  }
  const containerMargin =
    displaySeeMoreButton == "block"
      ? `0% 0% ${
          validateUserAgent() === "android"
            ? "2em"
            : !disableSeeMoreButton
            ? "2em"
            : "24%"
        }  0%`
      : `0% 0% ${
          validateUserAgent() === "android"
            ? "2em"
            : !disableSeeMoreButton
            ? "2em"
            : !withOfferTelcelWithoutLine
            ? "25%"
            : "5%"
        }  0%`;
  // const { categoryPlansId } = paymentsConfig.services[serviceConfigIndex].serviceData.info
  const marginButtonVerMas =
    categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
      ? "10% 10% 0em 10%"
      : `10% 10% ${validateUserAgent() === "android" ? "3em" : "24%"} 10%`;
  return (
    <Container>
      <div style={{ margin: containerMargin }}>
        {/* {
                    planCard2
                } */}
        {planCard}
      </div>
      <Button
        fontSize={isContainerTelcel && !isClaroPartner ? "16px" : "14px"}
        background={
          isContainerTelcel && !isClaroPartner ? "#7b1fa2" : "#000000"
        }
        font={isContainerTelcel && !isClaroPartner ? "AMX-Bold" : undefined}
        weight={isContainerTelcel && !isClaroPartner ? "normal" : "bold"}
        style={{ margin: marginButtonVerMas, display: displaySeeMoreButton }}
        onClick={handleButonSeeMore}
        border={
          isContainerTelcel && !isClaroPartner ? "2px solid #7b1fa2" : undefined
        }
      >
        {"Ver más paquetes"}
      </Button>
      {textLink.length ? (
        <div
          style={{
            margin: `0 auto ${
              validateUserAgent() === "android" ? "5em" : "30%"
            } auto`,
            width: "70%",
            textAlign: "center"
          }}
        >
          {textLink}
        </div>
      ) : (
        <></>
      )}
      {validity.length ? (
        <div
          style={{
            margin: `0 auto ${
              validateUserAgent() === "android" ? "5em" : "30%"
            } auto`,
            width: "94%",
          }}
        >
          {validity}
        </div>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default withRouter(HeaderPlans);
